import { findKey } from "lodash";
import { isClient } from "common/helper";
import { cleanEnv, str } from "envalid";

export const envConfig = cleanEnv(process.env, {
  REACT_APP_ENV: str(),
  REACT_APP_VERSION: str({ default: "0.0.0.0" }),
  REACT_APP_DEFAULT_LANG: str({ default: "th" }),
  NODE_ENV: str({ default: "development" }),
});

const config = {
  production: {
    HOST: "https://flex-backoffice.prod.zennite.co",
    API_ENDPOINT: "https://flex-api.prod.zennite.co/graphql",
    API: "https://flex-api.prod.zennite.co",
    BACKOFFICE_ENDPOINT: "https://flex-backoffice.prod.zennite.co",
    APP_ENDPOINT: "https://flex.prod.zennite.co",
    MARKETPLACE_ENDPOINT: "https://marketplace-api.prod.zennite.co",
  },
  demo: {
    HOST: "https://flex-backoffice.demo.zennite.co",
    API_ENDPOINT: "https://flex-api.demo.zennite.co/graphql",
    API: "https://flex-api.demo.zennite.co",
    BACKOFFICE_ENDPOINT: "https://flex-backoffice.demo.zennite.co",
    APP_ENDPOINT: "https://flex.demo.zennite.co",
    MARKETPLACE_ENDPOINT: "https://marketplace-api.demo.zennite.co",
  },
  uat: {
    HOST: "https://flex-backoffice.uat.zennite.co",
    API_ENDPOINT: "https://flex-api.uat.zennite.co/graphql",
    API: "https://flex-api.uat.zennite.co",
    BACKOFFICE_ENDPOINT: "https://flex-backoffice.uat.zennite.co",
    APP_ENDPOINT: "https://flex.uat.zennite.co",
    MARKETPLACE_ENDPOINT: "https://marketplace-api.uat.zennite.co",
  },
  dev: {
    HOST: "https://flex-backoffice.dev.zennite.co",
    API_ENDPOINT: "https://flex-api.dev.zennite.co/graphql",
    API: "https://flex-api.dev.zennite.co",
    BACKOFFICE_ENDPOINT: "https://flex-backoffice.dev.zennite.co",
    APP_ENDPOINT: "https://flex.dev.zennite.co",
    MARKETPLACE_ENDPOINT: "https://marketplace-api.dev.zennite.co",
  },
  staging: {
    HOST: "https://dev-scg2-flex-backoffice.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg2-flex-backoffice.moveplus.dynu.net/graphql",
    API: "https://dev-scg2-flex-api.moveplus.dynu.net",
    BACKOFFICE_ENDPOINT: "https://dev-scg2-flex-backoffice.moveplus.dynu.net",
    APP_ENDPOINT: "https://dev-scg2-flex-app.moveplus.dynu.net",
    MARKETPLACE_ENDPOINT: "https://marketplace-api-flexben-uat.scg.com",
  },
  staging2: {
    HOST: "http://localhost:9902",
    API_ENDPOINT: "http://localhost:9901/graphql",
    API: "http://localhost:9901",
    BACKOFFICE_ENDPOINT: "http://localhost:9902",
    APP_ENDPOINT: "http://localhost:9903",
    MARKETPLACE_ENDPOINT: "https://marketplace-api-flexben-uat.scg.com",
  },
  staging3: {
    HOST: "https://dev-scg-my-benefit-backoffice.moveplus.dynu.net",
    API_ENDPOINT:
      "https://dev-scg-my-benefit-backoffice.moveplus.dynu.net/graphql",
    API: "https://dev-scg-my-benefit-api.moveplus.dynu.net",
    BACKOFFICE_ENDPOINT:
      "https://dev-scg-my-benefit-backoffice.moveplus.dynu.net",
    APP_ENDPOINT: "https://dev-scg-my-benefit-app.moveplus.dynu.net",
    MARKETPLACE_ENDPOINT: "https://marketplace-api-flexben-uat.scg.com",
  },
  staging4: {
    HOST: "https://dev-scg1-my-benefit-backoffice.moveplus.dynu.net",
    API_ENDPOINT:
      "https://dev-scg1-my-benefit-backoffice.moveplus.dynu.net/graphql",
    API: "https://dev-scg-my-benefit-api.moveplus.dynu.net",
    BACKOFFICE_ENDPOINT:
      "https://dev-scg1-my-benefit-backoffice.moveplus.dynu.net",
    APP_ENDPOINT: "https://dev-scg1-my-benefit-app.moveplus.dynu.net",
    MARKETPLACE_ENDPOINT: "https://marketplace-api-flexben-uat.scg.com",
  },
  development: {
    HOST: "http://localhost:22902",
    API_ENDPOINT: "http://localhost:22901/graphql",
    API: "http://localhost:22901",
    BACKOFFICE_ENDPOINT: "http://localhost:22902",
    APP_ENDPOINT: "http://localhost:22903",
    MARKETPLACE_ENDPOINT: "https://marketplace-api-flexben-uat.scg.com",
  },
};

export const getEnvByHost = () =>
  isClient ? findKey(config, { HOST: window.location.origin }) : null;

export const nodeEnv = getEnvByHost() || "development";

console.log("HOST : ", getEnvByHost());

const appEnvConfig = {
  production: {
    HOST: "https://flex.prod.zennite.co",
    API_ENDPOINT: "https://flex-api.prod.zennite.co/graphql",
    API: "https://flex-api.prod.zennite.co",
  },
  demo: {
    HOST: "https://flex.demo.zennite.co",
    API_ENDPOINT: "https://flex-api.demo.zennite.co/graphql",
    API: "https://flex-api.demo.zennite.co",
  },
  uat: {
    HOST: "https://flex.uat.zennite.co",
    API_ENDPOINT: "https://flex-api.uat.zennite.co/graphql",
    API: "https://flex-api.uat.zennite.co",
  },
  dev: {
    HOST: "https://flex.dev.zennite.co",
    API_ENDPOINT: "https://flex-api.dev.zennite.co/graphql",
    API: "https://flex-api.dev.zennite.co",
  },
  staging: {
    HOST: "https://dev-scg2-flex-app.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg2-flex-app.moveplus.dynu.net/graphql",
    API: "https://dev-scg2-flex-api.moveplus.dynu.net",
  },
  staging2: {
    HOST: "http://localhost:9902",
    API_ENDPOINT: "http://localhost:9901/graphql",
    API: "http://localhost:9901",
  },
  staging3: {
    HOST: "https://dev-scg-my-benefit-app.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg-my-benefit-app.moveplus.dynu.net/graphql",
    API: "https://dev-scg-my-benefit-api.moveplus.dynu.net",
  },
  staging4: {
    HOST: "https://dev-scg1-my-benefit-app.moveplus.dynu.net",
    API_ENDPOINT: "https://dev-scg1-my-benefit-app.moveplus.dynu.net/graphql",
    API: "https://dev-scg1-my-benefit-api.moveplus.dynu.net",
  },
  development: {
    HOST: "http://localhost:22903",
    API_ENDPOINT: "http://localhost:22901/graphql",
    API: "http://localhost:22901",
  },
};

const MOCK_MSAL_CONFIG = {
  production: {
    REACT_APP_MSAL_CLIENT_ID: "aa3d3245-7975-475f-a0d2-f4728d3f9294",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://flex-backoffice.prod.zennite.co",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI:
      "https://flex-backoffice.prod.zennite.co",
  },
  demo: {
    REACT_APP_MSAL_CLIENT_ID: "aa3d3245-7975-475f-a0d2-f4728d3f9294",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://flex-backoffice.demo.zennite.co",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI:
      "https://flex-backoffice.demo.zennite.co",
  },
  uat: {
    REACT_APP_MSAL_CLIENT_ID: "aa3d3245-7975-475f-a0d2-f4728d3f9294",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://flex-backoffice.uat.zennite.co",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI:
      "https://flex-backoffice.uat.zennite.co",
  },
  dev: {
    REACT_APP_MSAL_CLIENT_ID: "aa3d3245-7975-475f-a0d2-f4728d3f9294",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://flex-backoffice.dev.zennite.co",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI:
      "https://flex-backoffice.dev.zennite.co",
  },
  staging: {
    REACT_APP_MSAL_CLIENT_ID: "96283f69-2148-4bf1-a97a-4478c83a8e41",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI:
      "https://dev-scg2-flex-backoffice.moveplus.dynu.net",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI:
      "https://dev-scg2-flex-backoffice.moveplus.dynu.net",
  },
  staging2: {
    REACT_APP_MSAL_CLIENT_ID: "96283f69-2148-4bf1-a97a-4478c83a8e41",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "http://localhost:9902",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "http://localhost:9902",
  },
  staging3: {
    REACT_APP_MSAL_CLIENT_ID: "96283f69-2148-4bf1-a97a-4478c83a8e41",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI:
      "https://dev-scg-my-benefit-backoffice.moveplus.dynu.net",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI:
      "https://dev-scg-my-benefit-backoffice.moveplus.dynu.net",
  },
  staging4: {
    REACT_APP_MSAL_CLIENT_ID: "96283f69-2148-4bf1-a97a-4478c83a8e41",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI:
      "https://dev-scg1-my-benefit-backoffice.moveplus.dynu.net",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI:
      "https://dev-scg1-my-benefit-backoffice.moveplus.dynu.net",
  },
  development: {
    REACT_APP_MSAL_CLIENT_ID: "96283f69-2148-4bf1-a97a-4478c83a8e41",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "http://localhost:22902",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "http://localhost:22902",
  },
};

export const appEnv = appEnvConfig[nodeEnv];

const env = {
  ...config[nodeEnv],
  ...MOCK_MSAL_CONFIG[nodeEnv],
};

console.log("ENV : ", env);
export default env;
